import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function CreateModal({
  createNewFixedFees,
  getNewFixedFeesList,
  history,
  getSingleNewFixedFees,
  creating,
  ordinanceRevisionId,
}) {
  const [formData, setFormData] = useState({
    code: '',
    description: '',
    multiplier: '',
    amount: '',
    for_new: 0,
    for_renewal: 0,
  });

  const validateForm = useFormValidator(formData, {
    code: 'required',
    description: 'required',
    multiplier: 'text_underscore',
    amount: 'required',
  });

  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
      code: _.get(formData, 'code').toUpperCase(),
      multiplier: (_.get(formData, 'multiplier') || '').toLowerCase(),
      for_new: _.get(formData, 'for_new') ? _.get(formData, 'for_new') : 0,
      for_renewal: _.get(formData, 'for_renewal')
        ? _.get(formData, 'for_renewal')
        : 0,
      ordinance_revision_id: ordinanceRevisionId,
    };

    createNewFixedFees(args, ({ data }) => {
      setModal({ isOpen: false });
      getNewFixedFeesList({ ordinance_revision_id: ordinanceRevisionId });
      history.push(`/bpls/tax-revenue/new-fixed-fees/${_.get(data, 'id')}`);
      getSingleNewFixedFees(data.id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    })
  };

  const onCheck = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked === true ? 1 : 0,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Code: {validateForm.renderMessage('code')}
            </label>
            <input
              className="form-control"
              type="text"
              name="code"
              onChange={onChange}
              placeholder="Ex. CODE-1234"
              style={{ textTransform: 'uppercase' }}
              value={_.get(formData, 'code')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Description: {validateForm.renderMessage('description')}
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Multiplier: {validateForm.renderMessage('multiplier')}
            </label>
            {/* <input
              className="form-control"
              type="text"
              name="multiplier"
              onChange={onChange}
              placeholder="Ex. code_multiplier"
              style={{ textTransform: 'lowercase' }}
              value={_.get(formData, 'multiplier')}
            /> */}
            <Select
              placeholder="Select Multiplier"
              onChange={handleOnChangeSelect('multiplier')}
              options={c.multiplierOption}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Amount: {validateForm.renderMessage('amount')}
            </label>
            <input
              className="form-control"
              type="number"
              name="amount"
              onChange={onChange}
              placeholder="Ex. 1.00"
              value={_.get(formData, 'amount')}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label">
              For New: &nbsp;
            </label>
            <input
              name="for_new"
              type="checkbox"
              checked={_.get(formData, 'for_new')}
              onChange={onCheck}
              required={formData.for_renewal === 0}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label">
              For Renewal: &nbsp;
            </label>
            <input
              name="for_renewal"
              type="checkbox"
              checked={_.get(formData, 'for_renewal')}
              onChange={onCheck}
              required={formData.for_new === 0}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  getNewFixedFeesList: PropTypes.instanceOf(Function).isRequired,
  createNewFixedFees: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleNewFixedFees: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_NEW_FIXED_FEES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
